import React from "react";
import { Link } from "react-router-dom";
import { Disc3 } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-neutral-800 bg-[var(--surface)]">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div>
          <Link to="/" className="flex items-center gap-2 mb-4">
            <Disc3 size={20} className="text-[var(--accent)]" />
            <span className="font-display text-2xl uppercase">HipHopIsTheCulture</span>
          </Link>
          <p className="font-mono-label text-[10px] text-neutral-500 leading-relaxed">
            DOCUMENTING THE SOUND, THE STYLE, THE SAGA. SINCE THE BEAT DROPPED.
          </p>
        </div>
        <div>
          <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3">LISTEN</div>
          <ul className="space-y-2 font-mono-label text-[11px] text-neutral-300">
            <li><Link to="/mixtapes" className="hover:text-white">Mixtapes</Link></li>
            <li><Link to="/singles" className="hover:text-white">Singles</Link></li>
            <li><Link to="/videos" className="hover:text-white">Videos</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3">SHOP</div>
          <ul className="space-y-2 font-mono-label text-[11px] text-neutral-300">
            <li><Link to="/merch" className="hover:text-white">Merch</Link></li>
            <li><Link to="/books" className="hover:text-white">Books</Link></li>
            <li><Link to="/cart" className="hover:text-white">Cart</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3">CONNECT</div>
          <ul className="space-y-2 font-mono-label text-[11px] text-neutral-300">
            <li><Link to="/culture-connect" className="hover:text-white">Culture Connect</Link></li>
            <li><Link to="/culture-pass" className="hover:text-white">Culture Pass</Link></li>
            <li><Link to="/culture-club" className="hover:text-[var(--accent)]" data-testid="footer-culture-club">Culture Club · Newsletter</Link></li>
            <li><Link to="/register" className="hover:text-white">Join</Link></li>
            <li><Link to="/login" className="hover:text-white">Sign In</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-4 flex justify-between font-mono-label text-[10px] text-neutral-500">
          <span>© 2026 HIPHOPISTHECULTURE.COM</span>
          <span>BUILT FOR THE CULTURE</span>
        </div>
      </div>
    </footer>
  );
}
